import React, { useEffect, useState,useRef } from "react";
import FilterComponent from "../FilterComponent/FilterComponent";
import "./ChannelsAndPacksComponent.css";
import HdIcon from "../../../images/img/hd-icon.svg";
import SdIcon from "../../../images/img/sd-icon.svg";
import RightIcon from "../../../images/icons/right-icons.svg";
import FilterIcon from "../../../images/icons/filter-icon.svg";
import defaultBox from "../../../images/img/default-box.png"; 
import defaultChannel from "../../../images/img/default-channel.png"; 
import apiService from "../../APIService";
import PackDescriptionComponent from "../PackDesription/PackDescriptionComponent";
import ScrollerWithArrows from "../../../Simplify360Chat/CommonUtils/ScrollerWithArrows";
export default function ChannelsAndPacksComponent(props) {
  //todo pack description component pending
  //todo onClick of view channel list component toggle PackDescription Componrnt with props
  //constants or variables
  const {
    channelsProps,
    packsProps,
    filters,
    selectedLanguagesProps,
    allLanguagesProps,
    selectedGenresProps,
    allGenresProps,
    
    filterTag,
    filterToggle,
    onClickSubmit,
    tag,
    code,
  } = props;
  const channelRef = useRef(null);
  const packsRef = useRef(null);
  //states
console.log(selectedLanguagesProps,
  allLanguagesProps,
  selectedGenresProps,
  allGenresProps,"CHANNELSANDPACKS")
  const [applyFilterToggle, setApplyFilterToggle] = useState(false);
  const [channels, setChannels] = useState(channelsProps);
  const [packs, setPacks] = useState(packsProps);
  const [count, setCount] = useState(0);
  const [refresh,setRefres] = useState(false);
  const [selectedGenres,setSelectedGenres] = useState(selectedGenresProps);
  const [selectedLanguages,setSelectedLanguages] = useState(selectedLanguagesProps);
  const [allGenres,setAllGenres] = useState(allGenresProps);
  const [allLanguages,setAllLanguages] = useState(allLanguagesProps);
  const [enableDescriptionComponent,setEnableDescriptionComponent] = useState({
    toggle:false,
    data:null
  });
  //useEffects
  useEffect(()=>{
    //map through all channels and set a checked filed as false
    //map through all packs and set a checked filed as false 
    channels.map((chan) =>
      
        chan.checked=false
        
      );
  },[])
  useEffect(()=>{
    
    packs.map((pa) =>
      
        pa.checked=false
        
      );
  },[])
  //functions
  const handleApplyFilters = () => {
    setApplyFilterToggle(!applyFilterToggle);
  };
  const onClickChannelHandler = (channel) => {
    var temp = [];
    if (channel.checked === false) {
      channel.checked = true;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    } else {
      channel.checked = false;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    }
 
    setChannels(temp);
  };
  const isSupportedImage =(imageLink)=>{
    console.log(imageLink,"image link")
    if(imageLink.toString().includes(".gif")){
      return imageLink;
    }else{
      return imageLink;
    }
  }
  
  const onPackClickHandler = (pack) => {
    var temp = [];
    if (pack.checked === false) {
      pack.checked = true;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    } else {
      pack.checked = false;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    }
    
    setPacks(temp);
  };
  const onConfirmHandler = () => {
    var selectedPacks = packs
      .filter((onePAck) => onePAck.checked === true)
      .map((onePack) => onePack.name);
    var selectedChannels = channels
      .filter((oneChannel) => oneChannel.checked === true)
      .map((oneChannel) => oneChannel.name);
    onClickSubmit(
      code,
      { channelName: selectedChannels, packName: selectedPacks },
      tag
    );
    filterToggle(true);

    
    localStorage.setItem(
      "selectedChannelsPAcks",
      JSON.stringify({ channelName:  selectedChannels, packName: selectedPacks })
    );
  };
  const updateCount=(data)=>{
    
    setCount(data)
    setRefres(!refresh);
    
  }
  const onClickFilterHandler = (code,data,tag) => {
 setApplyFilterToggle(false);
 apiService.chatPost(code, data).then(response => {
  
  var tempChannels=[]
  var tempPacks=[]
    tempChannels=response.data.chatResponse.entries[1].text_data?.channels?.channelList

  tempChannels!==undefined && tempChannels.map((chan) =>
      
        chan.checked=false
        
      );
        tempPacks=response.data.chatResponse.entries[1].text_data?.packsWithChannel?.packList

      tempPacks!==undefined &&tempPacks.map((pa) =>
      
        pa.checked=false
        
      );
      //  var tempChannels=[]
  //  var tempPacks=[]
  //   tempChannels=response.data.chatResponse.entries[1].text_data?.channels?.channelList
  //   tempPacks=response.data.chatResponse.entries[1].text_data?.packsWithChannel?.packList
     //take tempChannels -> response.data.chatResponse.entries[1].text_data?.channels?.channelList
     //take tempPacks -> response.data.chatResponse.entries[1].text_data?..packsWithChannel?.packList
     //mapthrough channels and packs and add checked as false
     //TODO - Bharath - localLanguagesAndGenre update here as per Conversation component post function
     
    console.log(response.data.chatResponse.entries[1].text_data,"HERE IN CHANNELS AND PACKS")
    setChannels(tempChannels);
    setPacks(tempPacks);
    setAllLanguages(response.data.chatResponse.entries[1].text_data?.filter?.language?.listOfLanguages);
    setSelectedLanguages(response.data.chatResponse.entries[1].text_data?.filter?.language?.selectedLanguages);
    setAllGenres(response.data.chatResponse.entries[1].text_data?.filter?.genre?.listOfGenre);
    setSelectedGenres(response.data.chatResponse.entries[1].text_data?.filter?.genre?.selectedGenre);
    setRefres(!refresh);
    setRefres(!refresh);
  
  })
  }
  const enableDescription =(data)=>{
    localStorage.setItem("packDescription",JSON.stringify(data));
setEnableDescriptionComponent({
  toggle:true,
  data:data
})

  }
  const selectDescription =(data)=>{
    onPackClickHandler(enableDescriptionComponent.data);
    setEnableDescriptionComponent({
      toggle:false,
      data:null
    })
  }
 
  //useEffects
  return (
    <div className="channelsAndPacksContainer">
      {enableDescriptionComponent.toggle && <PackDescriptionComponent 
      data= {enableDescriptionComponent.data}
      closeDescriptionComponent={()=>setEnableDescriptionComponent(false)}
      selectDesctipon={()=>selectDescription()}
      />}
      <div className="applyFilterContainer">
        {applyFilterToggle && count > 0 && <div key={count} id="filterCount">{count}</div>}
        <div className="buttonContainer btn-animate chat-label">
          <img src={FilterIcon}></img>
          <span onClick={() => handleApplyFilters()}>Apply Filters</span>
        </div>
      </div>
      <div className="filterContainer-packList">
        {applyFilterToggle ? (
          <FilterComponent
            filters={filters}
            selectedLanguagesProps={selectedLanguages}
            allLanguagesProps={allLanguages}
            selectedGenresProps={selectedGenres }
            allGenresProps={allGenres}
            onClickFilter={onClickFilterHandler}
            filterTag={filterTag}
            filterToggle={filterToggle}
            setCount={updateCount}
            code={localStorage.getItem("filterCode")}
          />
        ) : null}
      </div>
    {channels && channels.length !== 0 &&  <div className="channelsListContainer">
        <div className="channelsHeaderContainer">
          <p>Channels</p>
          <span></span>
          
        </div>
        <ScrollerWithArrows width="100%" height="12rem" >
        <div className="channelsSliderContainer" id="hscrollChannels" ref= {channelRef} width="100%">

          {
          channels && channels.length !== 0 ? (
            channels.map((oneChannel,index) => (
              <div
              key={index}
                className="oneChannelBox"
                
                onClick={() => onClickChannelHandler(oneChannel)}
                style={{
                  border: oneChannel.checked ? "1px solid #F07FC8" : "none",
                  width:'30%'
                }}
              >
                <div className="oneChannel-checkbox">
                  <input
                    type="checkbox"
                    value={oneChannel.name}
                    checked={oneChannel.checked}
                  ></input>
                </div>
                <div className="oneChannel-nameLogo">
                  <img src={ oneChannel.imageLink} onError={(e)=>e.target.src= defaultChannel}></img>
                  <p>{oneChannel.name}</p>
                </div>
                <div className="oneChannel-priceContainer">
                  <p>{oneChannel.description}</p>
                </div>
              </div>
            ))
          ) : 
          <p>No Channels</p>
          }
        </div>
        </ScrollerWithArrows>
      </div>}
   {packs && packs.length !== 0 &&   <div className="packsListContainer">
        <div className="packsList-header">
          <p>Packs with the channel</p>
          <span></span>
        </div>
        <ScrollerWithArrows width="100%" height="14rem">
        <div className="packsSilderContainer" id="hscrollPacks" ref= {packsRef}>
          { packs.length !== 0 ? (
            packs.map((onePack,index) => (
              <div
              key={index}
                className="onePackBox"
                onClick={() => onPackClickHandler(onePack)}
                style={{
                  border: onePack.checked ? "1px solid #F07FC8" : "none",
                  width:'60%'
                }}
              >
                <div className="onePackBox-checkbox">
                  <input
                    type="checkbox"
                    value={onePack}
                    checked={onePack.checked}
                  ></input>
                  <p>{onePack.name}</p>
                </div>
                <div className="onePackBox-price">
                  <p>{onePack.description}</p>{" "}
                </div>
                <div className="onePackBox-hdsd">
                  <div className="hdSdContainer">
                    <img src={SdIcon}></img>
                    <p>{onePack.noOfHdChannels}</p>
                  </div>
                  <div className="hdSdContainer">
                    <img src={HdIcon}></img>
                    <p>{onePack.noOfSdChannels}</p>
                  </div>
                </div>
                <div className="onePackBox-link" onClick={()=>enableDescription(onePack)}>
                  <p  >View Channel List</p>
                  <img src={RightIcon}></img>
                </div>
              </div>
            ))
          ) : (
            <p>No Packs</p>
          )}
        </div>
        </ScrollerWithArrows>
      </div>}
      <div className="confirmButtonContainer-channelsAndPacks">
        <a
        disabled={channels?.length === 0 && packs?.length === 0}
          className="action-tab top-level-menu btn btn-primary btn-lg waves-effect waves-light confirm-btn "
          style={{
            borderRadius: "20px",
            textAlign: "center",
            fontSize: "12px",
            // marginRight:"7%",
          }}
          onClick={channels?.length === 0 && packs?.length === 0 ? console.log("no channels or packs found") :() => onConfirmHandler()}
        >
          <p>Confirm</p>
        </a>
        {/* <a
        className="action-tab top-level-menu btn btn-primary btn-lg waves-effect waves-light confirm-btn back-styling"
        style={{
          borderRadius: "20px",
          textAlign: "center",
          fontSize: "12px",
        }}>
          <p>Back</p>
        </a> */}
      </div>
    </div>
  );
}
